import moment from 'moment'
import * as api from '../../api/lead/followUps'
import { fetchLeadDetails } from '../leadDetails'
import { all, fork, call, put, takeLatest } from 'redux-saga/effects'
import { constants } from '../../modules/leadFunctions/leadFollowUpActions'

function* followUpsRefresh(action) {
  try {
    const payload = yield call(api.getLeadFollowUps, action.leadId)
    yield put({ type: constants.LEAD_FOLLOW_UPS_REFRESH.SUCCESS, payload })

    action.next && action.next(null, payload)
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.LEAD_FOLLOW_UPS_REFRESH.FAILED,
      message: e.message || e
    })
  }
}

function* watchFollowUps() {
  yield takeLatest(constants.LEAD_FOLLOW_UPS_REFRESH.ACTION, followUpsRefresh)
}

function* sagaCreateFollowUp(action) {
  try {
    const payload = {
      lead_id: action.leadId,
      type: action.content.type,
      due_date: moment(action.content.due_date).format('YYYY-MM-DD hh:mm:ss'),
      description: action.content.description,
      status: action.content.status,
      created_by_id: action.userId,
      updated_by_id: action.userId,
      assigned_to_id:
        action.content.assigned_to_type === 'user' ? action.content.assigned_to_id : null,
      assigned_to_role_id:
        action.content.assigned_to_type === 'role' ? action.content.assigned_to_role_id : null
    }
    yield call(api.createLeadFollowUp, payload)
    yield put({ type: constants.LEAD_FOLLOW_UP_CREATE.SUCCESS, payload })
    yield call(followUpsRefresh, { leadId: action.leadId })
    yield call(fetchLeadDetails, { leadId: action.leadId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.LEAD_FOLLOW_UP_CREATE.FAILED,
      message: e.message || e
    })
  }
}

function* watchCreateFollowUp() {
  yield takeLatest(constants.LEAD_FOLLOW_UP_CREATE.ACTION, sagaCreateFollowUp)
}

function* sagaUpdateFollowUp(action) {
  try {
    const payload = {
      follow_up_data: {
        type: action.content.type,
        due_date: moment(action.content.due_date).format('YYYY-MM-DD hh:mm:ss'),
        description: action.content.description,
        status: action.content.status,
        updated_by_id: action.userId,
        assigned_to_id:
          action.content.assigned_to_type === 'user' ? action.content.assigned_to_id : null,
        assigned_to_role_id:
          action.content.assigned_to_type === 'role' ? action.content.assigned_to_role_id : null
      },
      lead_follow_up_id: action.followUpId,
      actor_name: action.content.actorName,
      lead_id: action.leadId
    }
    yield call(api.updateLeadFollowUp, payload)
    yield put({ type: constants.LEAD_FOLLOW_UP_UPDATE.SUCCESS, payload })
    yield call(followUpsRefresh, { leadId: action.leadId })
    yield call(fetchLeadDetails, { leadId: action.leadId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.LEAD_FOLLOW_UP_UPDATE.FAILED,
      message: e.message || e
    })
  }
}

function* watchUpdateFollowUp() {
  yield takeLatest(constants.LEAD_FOLLOW_UP_UPDATE.ACTION, sagaUpdateFollowUp)
}

function* sagaDeleteFollowUp(action) {
  try {
    const payload = {
      lead_follow_up_id: action.followUpId
    }
    yield call(api.deleteLeadFollowUp, payload)
    yield put({ type: constants.LEAD_FOLLOW_UP_DELETE.SUCCESS, payload })
    yield call(followUpsRefresh, { leadId: action.leadId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.LEAD_FOLLOW_UP_DELETE.FAILED,
      message: e.message || e
    })
  }
}

function* watchDeleteFollowUp() {
  yield takeLatest(constants.LEAD_FOLLOW_UP_DELETE.ACTION, sagaDeleteFollowUp)
}

function* getFollowUpActivities(action) {
  try {
    const payload = yield call(api.getLeadFollowUpActivities, action.followUpId)
    yield put({ type: constants.GET_LEAD_FOLLOW_UP_ACTIVITIES.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_LEAD_FOLLOW_UP_ACTIVITIES.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetFollowUpActivities() {
  yield takeLatest(constants.GET_LEAD_FOLLOW_UP_ACTIVITIES.ACTION, getFollowUpActivities)
}

/**
 * Export the root saga by forking all available sagas.
 */
export function* rootSaga() {
  // add more sagas here
  yield all([
    fork(watchFollowUps),
    fork(watchCreateFollowUp),
    fork(watchUpdateFollowUp),
    fork(watchDeleteFollowUp),

    fork(watchGetFollowUpActivities)
  ])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/leadFunctions/leadFollowUpSaga.js